export const isBackOfficePathname = (pathname: string): boolean => {
  const [, , pagePath] = pathname.split("/")

  return pagePath === "backend"
}
